import React, { useState } from "react";
import "./MisCertificates.css";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export default function MisCertificates() {
  const [form, setForm] = useState({
    receiptNo: "",
    date: "",
    receivedFrom: "",
    acNo: "",
    nomineeName: "",
    typesOfDeposit: "",
    age: "",
    relation: "",
  });
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };
  const generatePDF = async () => {
  const input1 = document.getElementById('page1');
  const input2 = document.getElementById('page2');
  const pdf = new jsPDF("p", "mm", "a4");
  // page 1

  const canvas1 = await html2canvas(input1, { scale: 2, useCORS: true , backgroundColor: "#ffffffff" });
  const imgData1 = canvas1.toDataURL('image/png');
  const imgWidth1 = 210;
  const pageHeight1 = 297;
  const imgHeight1 = (canvas1.height * imgWidth1) / canvas1.width;
  pdf.addImage(imgData1, 'PNG', 0, 0, imgWidth1, imgHeight1);

  // page 2 
  pdf.addPage();
  const canvas2 = await html2canvas(input2, { scale: 2 , useCORS: true , backgroundColor: "#ffffffff"});
  const imgData2 = canvas2.toDataURL('image/png');
  const imgWidth2 = 210;
  const pageHeight2 = 297;
  const imgHeight2 = (canvas2.height * imgWidth2) / canvas2.width;
  pdf.addImage(imgData2, 'PNG', 0, 0, imgWidth2, imgHeight2);

  pdf.save("Mis_Certificate.pdf");
};
const data = {
    receipt: "SBIN000012312",
    nomineeName: "Mahendra Singh ",
    acNo: "SBIN000012312",
    received: "Monika",

 }

  
  return (
    <div className="Miscertificates-containers">
      <div id="page1">
    <div className="Miscertificates-container">
      <div className="Miscertificates-box">
        <div className="Misheaders">
          <div className="Mislefts">
            <div className="Mislogos">
            <img src="techvisionproject\src\assets\image\Screenshot 2025-09-24 111702.png" alt="Logo" />
            </div>
            <div>
              <h1 className="Mistitles">SANPANNATA MUTUAL BENEFIT NIDHI LIMITED.</h1>
              <p className="Missubtitles">Reg. No. : U64199MH2023PLN405930</p>
              <p className="Missubtitles">
                Reg. Office & H.O.: Flat No. 2, Bldg. No. 2B, Ground Floor, Shree Gokul CHS,
                Vrindavan Society, Near Vrindavan Bus Stop, Thane (W) - 400601, Maharashtra
              </p>
            </div>
          </div></div>
          <div className="mis-header-container">
  <div className="mis-header-line"></div>

  <div className="mis-header-banner">
    <span className="mis-header-text-hindi">एमआईएस प्रमाणपत्र</span>
    <span className="mis-header-separator">/</span>
    <span className="mis-header-text-english">Mis Certificate</span>
  </div>

  <div className="mis-header-line"></div>

  <div className="mis-header-office-copy">Office Copy</div>
</div>

        

        <div className="Misinfos-section">
          <div className="Mislefts-info">
            <div className="Misfields">
              <label> Receipt No. &nbsp;&nbsp;&nbsp;:-  &nbsp;&nbsp;&nbsp;{data.receipt}<br />(रसीद संख्या)</label>
              {/* <input name="receiptNo" value={form.receiptNo} /> */}
            </div>
            
            <div className="Misfields">
              <label>Received From Shri/Smt. :-  &nbsp;{data.received} <br /> (श्री/श्रीमती से प्राप्त) </label>
              {/* <input name="receivedFrom" value={form.receivedFrom}  /> */}

            </div>
            <div className="Misfields">
              <label> A/C. No. &nbsp;&nbsp;&nbsp;:- &nbsp;&nbsp;&nbsp;{data.acNo}<br />(खाता सं.)</label>
              {/* <input name="acNo" value={form.acNo}  /> */}
            </div>
            <div className="Misfields">
              <label>Nominee Name  &nbsp;&nbsp;:- &nbsp;&nbsp;&nbsp;{data.nomineeName}<br />(नामांकित व्यक्ति का नाम)</label>
              {/* <input name="nomineeName" value={form.nomineeName} /> */}
            </div>
            <div className="Misfields">
              <label>Types of Deposit   &nbsp;:- &nbsp;&nbsp;&nbsp;{data.receipt}<br />(जमा के प्रकार)</label>
              {/* <input
                name="typesOfDeposit"
                value={form.typesOfDeposit}
                
              /> */}
            </div>
          </div>

          <div className="Misrights-info">
            <div className="Misfields">
              <label> Date &nbsp; :- &nbsp;&nbsp;&nbsp;{data.receipt} <br />(दिनांक)</label>
              {/* <input name="date" value={form.date}  /> */}
            </div>
            <div className="Misfields">
              <label>Age &nbsp; :- &nbsp;&nbsp;&nbsp;{data.receipt}<br />(आयु)</label>
              {/* <input name="age" value={form.age}  /> */}
            </div>
            <div className="Misfields">
              <label>Relation &nbsp; :-&nbsp;&nbsp;&nbsp;{data.receipt}<br />(रिश्ता)</label>
              {/* <input name="relation" value={form.relation} /> */}
            </div>
            <div className="Misfields">
              <label>A/C. No. &nbsp; :- &nbsp;&nbsp;&nbsp;{data.receipt}<br />(खाता सं.)</label>
              {/* <input name="acNo" value={form.acNo}  /> */}
            </div>
          </div>
        </div>

     
    <div className="MisCdeposit-table">
      <table>
        <thead>
          <tr>
            <th rowSpan="2">
              Deposit Amount<br />In Rupees
              <span className="Mishindi">रुपयों में जमा राशि</span>
            </th>
            <th rowSpan="2">
              Deposit Date<br />
              <span className="hindi">जमा तिथि</span>
            </th>
            <th colSpan="2" className="Misc-hindi">
              Period <br />
              <span className="">कालअवधि</span>
            </th>
            
            <th rowSpan="2">
              Rate of Int P. A.<br />
              <span className="hindi">वार्षिक ब्याज दर</span>
            </th>
            <th rowSpan="2">
              Due Date<br />
              <span className="hindi">नियत तारीख</span>
            </th>
            <th rowSpan="2">
              Maturity Amt.<br />
              <span className="hindi">परिपक्वता राशि</span>
            </th>
          </tr>
          <tr>
            <th>
              Month<br />
              <span className="hindi">महीना</span>
            </th>
            <th>
              Days<br />
              <span className="hindi">दिवस</span>
            </th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td></td>
            <td className="inner"></td>
            <td className="inner"></td>
            <td> <br /><br /><br />  </td>
            <td>   </td>
          </tr>
        </tbody>
      </table>
    </div>
     <div className="Misfooter">
          <div><br /> Cashier / कैशियर</div>
          <div><br /> Br. Manager / शाखाप्रमुख</div>
          <div><br /> Chairman / अध्यक्ष</div>  
      </div>
      </div>   </div>

       
        <div className="divider"></div>
      {/* End of 1st Container */}

      {/* Start of 2nd  Container */}
      
<div className="Miscertificates-container">
      <div className="Miscertificates-box">
        <div className="Misheaders">
          <div className="Mislefts">
            <div className="Mislogos">
                <img src="techvisionproject\src\assets\image\Screenshot 2025-09-24 111702.png" alt="Logo" />

            </div>
            <div>
              <h1 className="Mistitles">SANPANNATA MUTUAL BENEFIT NIDHI LIMITED.</h1>
              <p className="Missubtitles">Reg. No. : U64199MH2023PLN405930</p>
              <p className="Missubtitles">
                Reg. Office & H.O.: Flat No. 2, Bldg. No. 2B, Ground Floor, Shree Gokul CHS,
                Vrindavan Society, Near Vrindavan Bus Stop, Thane (W) - 400601, Maharashtra
              </p>
            </div>
          </div></div>
       <div className="mis-header-container">
  <div className="mis-header-line"></div>

  <div className="mis-header-banner">
    <span className="mis-header-text-hindi">एमआईएस प्रमाणपत्र</span>
    <span className="mis-header-separator">/</span>
    <span className="mis-header-text-english">Mis Certificate</span>
  </div>

  <div className="mis-header-line"></div>

  <div className="mis-header-office-copy">Customer Copy</div>
</div>

        

        <div className="Misinfos-section">
          <div className="Mislefts-info">
           <div className="Misfields">
              <label> Receipt No. &nbsp;&nbsp;&nbsp;:-  &nbsp;&nbsp;&nbsp;{data.receipt}<br />(रसीद संख्या)</label>
              {/* <input name="receiptNo" value={form.receiptNo} /> */}
            </div>
            
            <div className="Misfields">
              <label>Received From Shri/Smt. &nbsp;&nbsp;:-  &nbsp;&nbsp;&nbsp;{data.received} <br /> (श्री/श्रीमती से प्राप्त) </label>
              {/* <input name="receivedFrom" value={form.receivedFrom}  /> */}

            </div>
            <div className="Misfields">
              <label> A/C. No. &nbsp;&nbsp;&nbsp;:- &nbsp;&nbsp;&nbsp;{data.receipt}<br />(खाता सं.)</label>
              {/* <input name="acNo" value={form.acNo}  /> */}
            </div>
            <div className="Misfields">
              <label>Nominee Name  &nbsp;&nbsp;:- &nbsp;&nbsp;&nbsp;{data.nomineeName}<br />(नामांकित व्यक्ति का नाम)</label>
              {/* <input name="nomineeName" value={form.nomineeName} /> */}
            </div>
            <div className="Misfields">
              <label>Types of Deposit   &nbsp;:- &nbsp;&nbsp;&nbsp;{data.receipt}<br />(जमा के प्रकार)</label>
              {/* <input
                name="typesOfDeposit"
                value={form.typesOfDeposit}
                
              /> */}
            </div>
          </div>

          <div className="Misrights-info">
            <div className="Misfields">
              <label> Date &nbsp; :- &nbsp;&nbsp;&nbsp;{data.receipt} <br />(दिनांक)</label>
              {/* <input name="date" value={form.date}  /> */}
            </div>
            <div className="Misfields">
              <label>Age &nbsp; :- &nbsp;&nbsp;&nbsp;{data.receipt}<br />(आयु)</label>
              {/* <input name="age" value={form.age}  /> */}
            </div>
            <div className="Misfields">
              <label>Relation &nbsp; :-&nbsp;&nbsp;&nbsp;{data.receipt}<br />(रिश्ता)</label>
              {/* <input name="relation" value={form.relation} /> */}
            </div>
            <div className="Misfields">
              <label>A/C. No. &nbsp; :- &nbsp;&nbsp;&nbsp;{data.receipt}<br />(खाता सं.)</label>
              {/* <input name="acNo" value={form.acNo}  /> */}
            </div>
          </div>
        </div>

      
    <div className="MisCdeposit-table">
      <table>
        <thead>
          <tr>
            <th rowSpan="2">
              Deposit Amount<br />In Rupees
              <span className="Mishindi">रुपयों में जमा राशि</span>
            </th>
            <th rowSpan="2">
              Deposit Date<br />
              <span className="hindi">जमा तिथि</span>
            </th>
            <th colSpan="2" className="Misc-hindi">
              Period <br />
              <span className="">कालअवधि</span>
            </th>
            
            <th rowSpan="2">
              Rate of Int P. A.<br />
              <span className="hindi">वार्षिक ब्याज दर</span>
            </th>
            <th rowSpan="2">
              Due Date<br />
              <span className="hindi">नियत तारीख</span>
            </th>
            <th rowSpan="2">
              Maturity Amt.<br />
              <span className="hindi">परिपक्वता राशि</span>
            </th>
          </tr>
          <tr>
            <th>
              Month<br />
              <span className="hindi">महीना</span>
            </th>
            <th>
              Days<br />
              <span className="hindi">दिवस</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td></td>
            <td className="inner"></td>
            <td className="inner"></td>
            <td> <br /><br /><br />  </td>
            <td>   </td>
          </tr>
        </tbody>
      </table>
    </div>
     <div className="Misfooter">
          <div><br /> Cashier / कैशियर</div>
          <div><br /> Br. Manager / शाखाप्रमुख</div>
          <div><br /> Chairman / अध्यक्ष</div>  
      </div>
       </div>  </div></div>
      {/* End of 2nd Container */}

      {/* start of 1st Notice */}
 <div className="Misdivider"></div>
     <div id="page2">
    <div className="MisCnotice-container">
      {/* --- Heading --- */}
      <div className="MisCspecial-notice-header">
        <span className="MisCenglish-heading">Special Notice / </span>
        <span className="MisCmarathi-heading">विशेष सुचना</span>
      </div>

      {/* --- Rules/Points Section --- */}
      <div className="MisCrules-section">
        {/* Point 1 */}
        <div className="Misleft1-info">
        <div className="MisCrule-item">
          <span className="MisCrule-number">1.</span>
          <div className="MisCrule-text">
            <p className="MisCenglish-text">
               The Deposit will be accepted/renewed in rounded multiples of Rs. 100/- The
    amount’s excess of multiple of Rs. 100/- and/or fractions thereof will be refunded
            </p>
          </div>
        </div>

        {/* Point 2 */}
        <div className="MisCrule-item">
          <span className="MisCrule-number">2.</span>
          <div className="MisCrule-text">
            <p className="MisCenglish-text">
               Deposit receipt is not transferable by endorsement nor the amount of deposit is withdrawable in part/s However the depositor can avail loan facility against the security of deposit as per rules.
            </p>
          </div>
        </div>

        {/* Point 3 */}
        <div className="MisCrule-item">
          <span className="MisCrule-number">3.</span>
          <div className="MisCrule-text">
            <p className="MisCenglish-text">
              Receipt in favour of joint holders will be issued in the name of two or more persons
              and be made payable to any one of them or to the survivor’s as per mandate.
            </p>
          </div>
        </div>

        {/* Point 4 */}
        <div className="MisCrule-item">
          <span className="MisCrule-number">4.</span>
          <div className="MisCrule-text">
            <p className="MisCenglish-text">
              Due date of deposit will be recorded on the receipt to enable the depositor either to
              receive payment of the amount due or to arrange for renewal of the deposits on the
              receive payment of the amount due or to arrange for renewal of the deposits on the
              due date. No/further intimation will be given to depositor.
              
            </p>
          </div>
        </div>
        {/* Point 5 */}
        <div className="MisCrule-item">
          <span className="MisCrule-number">5.</span>
          <div className="MisCrule-text">
            <p className="MisCenglish-text">
              The interstrate are subject to change from time to time.
            </p>
          </div>
        </div>
        
        </div>
      
        {/* Point 6 */}
        <div className="Misright1-info">
<div className="MisCrule-item">
          <span className="MisCrule-number">6.</span>
          <div className="MisCrule-text">
            <p className="MisCenglish-text">
              At the time of receiving the payment or renewal on due date of deposits the deposit
revenue stamp other than Co-Operative societies and Shareholders.
receipt must be returned duly signed & discharged by the depositors by affixing Rs1/-
            </p>
          </div>
        </div>

            {/* Point 7 */}
<div className="MisCrule-item">
          <span className="MisCrule-number">7.</span>
          <div className="MisCrule-text">
            <p className="MisCenglish-text">
              The Society shall have lien on all deposits and reserve to itself, the right to appropriate
              it towards any liability of the depositors.
            </p>
          </div>
        </div>

            {/* Point 8 */}
<div className="MisCrule-item">
          <span className="MisCrule-number">8.</span>
          <div className="MisCrule-text">
            <p className="MisCenglish-text">
              Encashment of FD. before
              The date of maturity will be at descreation of the SMPNP and will be allowed at the 
              rate of interest prescribed as per directives of MCA.
            </p>
          </div>
        </div>

            {/* Point 9 */}
<div className="MisCrule-item">
          <span className="MisCrule-number">9.</span>
          <div className="MisCrule-text">
            <p className="MisCenglish-text">
              Individual Depositor can nominate a person at his own choice who is competent to
              contract Incase nominee is minor the depositor should appoint guardian.
            </p>
          </div>
        </div>

            {/* Point 10 */}
<div className="MisCrule-item">
          <span className="MisCrule-number">10.</span>
          <div className="MisCrule-text">
            <p className="MisCenglish-text">
              Renewal is available only on presentation of matured receiptwithin 14 day
              the date of its maturity.
            </p>
          </div>
        </div></div>

      </div>
      

      {/* --- Table Section --- */}
        <div className="MisCsdeposit-table">
      <table>
        <thead>
            <tr className ="Miscsub">PARTICULARS OF INTEREST AND RENEWALS</tr>
          <tr>
            <th>
              {/* Per Month Rs. <br /> */}
              <span className="MisCssub">Date of Renewal <br /> प्रति माह रु.</span>
            </th>
            
            <th>
              {/* Duration <br /> */}
              <span className="MisCssub">Amount Renewed <br /> अवधि</span>
            </th>
            <th>
              {/* Interest Rate <br /> */}
              <span className="MisCssub">Period <br /> व्याज दर</span>
            </th>
            <th>
              {/* Due Date <br /> */}
              <span className="MisCssub">Due Date <br />नियत तारीख</span>
            </th>
            <th>
              {/* Maturity Amt. <br /> */}
              <span className="MisCssub">Interest Paid/Payable<br /> परिपक्वता राशि</span>
            </th>
             <th>
              {/* Maturity Amt. <br /> */}
              <span className="MisCssub">Signature of Authorised Officials wih Seal<br /> परिपक्वता राशि</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><br /></td>
            <td>   </td>
            <td>   </td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td><br /></td>
            <td>   </td>
            <td>   </td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
      {/* --- Footer/Signature Section --- */}
      <div className="MisCsignature-section">
        <div className="MisCreceipt-confirmation">
          <p className="MisCenglish-text">
           Received the within mentioned Principal Amount and Interest due thereon in
          </p>
        </div>

<div className="MisCreceipt-confirmation">
          <p className="FDCenglish-text">
           Cash/by transfer to ________________________  Lien noted for Overdraft A/c No. _____________________________
           Signature/s verified _________________________________________
          </p>
        </div>
            <div className="MisCsignatures">
            <div className="MisCenglish-text"><br /><h4>**Director**</h4></div>
            <div className="MisCmarathi-text"><h5>**Signature of Depositor’s**</h5></div>
        </div>
        </div>
    </div>
    <div className="MisC-headline">
    <h3 className="MisCfooter-heading">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
       Received Term Deposit Receipt on ____________________________  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
       Signature _______________________________   </h3> </div>


     {/* End  of 1st Notice */}

{/* start of 1st Notice */}
 <div className="Misdivider"></div>
     <div id="page2">
    <div className="MisCnotice-container">
      {/* --- Heading --- */}
      <div className="MisCspecial-notice-header">
        <span className="MisCenglish-heading">Special Notice / </span>
        <span className="MisCmarathi-heading">विशेष सुचना</span>
      </div>

      {/* --- Rules/Points Section --- */}
      <div className="MisCrules-section">
        <div className="Misleft1-info"> 
        {/* Point 1 */}
        <div className="MisCrule-item">
          <span className="MisCrule-number">1.</span>
          <div className="MisCrule-text">
            <p className="MisCenglish-text">
               The Deposit will be accepted/renewed in rounded multiples of Rs. 100/- The
    amount’s excess of multiple of Rs. 100/- and/or fractions thereof will be refunded
            </p>
          </div>
        </div>

        {/* Point 2 */}
        <div className="MisCrule-item">
          <span className="MisCrule-number">2.</span>
          <div className="MisCrule-text">
            <p className="MisCenglish-text">
               Deposit receipt is not transferable by endorsement nor the amount of deposit is withdrawable in part/s However the depositor can avail loan facility against the security of deposit as per rules.
            </p>
          </div>
        </div>

        {/* Point 3 */}
        <div className="MisCrule-item">
          <span className="MisCrule-number">3.</span>
          <div className="MisCrule-text">
            <p className="MisCenglish-text">
              Receipt in favour of joint holders will be issued in the name of two or more persons
              and be made payable to any one of them or to the survivor’s as per mandate.
            </p>
          </div>
        </div>
       

        {/* Point 4 */}
        <div className="MisCrule-item">
          <span className="MisCrule-number">4.</span>
          <div className="MisCrule-text">
            <p className="MisCenglish-text">
              Due date of deposit will be recorded on the receipt to enable the depositor either to
              receive payment of the amount due or to arrange for renewal of the deposits on the
              receive payment of the amount due or to arrange for renewal of the deposits on the
              due date. No/further intimation will be given to depositor.
              
            </p>
          </div>
        </div> 
        
         {/* Point 5 */}
<div className="MisCrule-item">
          <span className="MisCrule-number">5.</span>
          <div className="MisCrule-text">
            <p className="MisCenglish-text">
              The interstrate are subject to change from time to time.
            </p>
          </div>
        </div>

        </div>

        
      
        <div className="Misright1-info">
      
        {/* Point 6 */}
<div className="MisCrule-item">
          <span className="MisCrule-number">6.</span>
          <div className="MisCrule-text">
            <p className="MisCenglish-text">
              At the time of receiving the payment or renewal on due date of deposits the deposit
revenue stamp other than Co-Operative societies and Shareholders.
receipt must be returned duly signed & discharged by the depositors by affixing Rs1/-
            </p>
          </div>
        </div>

            {/* Point 7 */}
<div className="MisCrule-item">
          <span className="MisCrule-number">7.</span>
          <div className="MisCrule-text">
            <p className="MisCenglish-text">
              The Society shall have lien on all deposits and reserve to itself, the right to appropriate
              it towards any liability of the depositors.
            </p>
          </div>
        </div>


    

            {/* Point 8 */}
<div className="MisCrule-item">
          <span className="MisCrule-number">8.</span>
          <div className="MisCrule-text">
            <p className="MisCenglish-text">
              Encashment of FD. before
              The date of maturity will be at descreation of the SMPNP and will be allowed at the 
              rate of interest prescribed as per directives of MCA.
            </p>
          </div>
        </div>

            {/* Point 9 */}
<div className="MisCrule-item">
          <span className="MisCrule-number">9.</span>
          <div className="MisCrule-text">
            <p className="MisCenglish-text">
              Individual Depositor can nominate a person at his own choice who is competent to
              contract Incase nominee is minor the depositor should appoint guardian.
            </p>
          </div>
        </div>

            {/* Point 10 */}
<div className="MisCrule-item">
          <span className="MisCrule-number">10.</span>
          <div className="MisCrule-text">
            <p className="MisCenglish-text">
              Renewal is available only on presentation of matured receiptwithin 14 day
              the date of its maturity.
            </p>
          </div>
        </div></div>

      </div>
      

      {/* --- Table Section --- */}
        <div className="MisCsdeposit-table">
      <table>
        <thead>
            <tr className ="Miscsub">PARTICULARS OF INTEREST AND RENEWALS</tr>
          <tr>
            <th>
              {/* Per Month Rs. <br /> */}
              <span className="MisCssub">Date of Renewal <br /> प्रति माह रु.</span>
            </th>
            
            <th>
              {/* Duration <br /> */}
              <span className="MisCssub">Amount Renewed <br /> अवधि</span>
            </th>
            <th>
              {/* Interest Rate <br /> */}
              <span className="MisCssub">Period <br /> व्याज दर</span>
            </th>
            <th>
              {/* Due Date <br /> */}
              <span className="MisCssub">Due Date <br />नियत तारीख</span>
            </th>
            <th>
              {/* Maturity Amt. <br /> */}
              <span className="MisCssub">Interest Paid/Payable<br /> परिपक्वता राशि</span>
            </th>
             <th>
              {/* Maturity Amt. <br /> */}
              <span className="MisCssub">Signature of Authorised Officials wih Seal<br /> परिपक्वता राशि</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><br /></td><td></td><td></td><td></td><td></td>
<td></td>
          </tr>
          <tr>
            <td><br /></td>
            <td>   </td>
            <td>   </td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        
        </tbody>
      </table>
    </div>
      {/* --- Footer/Signature Section --- */}
      <div className="MisCsignature-section">
        <div className="MisCreceipt-confirmation">
          <p className="MisCenglish-text">
           Received the within mentioned Principal Amount and Interest due thereon in
          </p>
        </div>

<div className="MisCreceipt-confirmation">
          <p className="MisCenglish-text">
           Cash/by transfer to ________________________  Lien noted for Overdraft A/c No.____________________________
            Signature/s verified _________________________________________
          </p>
        </div>
        <div className="MisCsignatures">
            <div className="MisCenglish-text"><br /><h4>**Director**</h4></div>
            <div className="MisCmarathi-text"><h5>**Signature of Depositor’s**</h5></div>
        </div></div>
    </div>
    <div className="MisC-headline">
    <h3 className="MisCfooter-heading">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
       Received Term Deposit Receipt on ____________________________  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
       Signature _______________________________   </h3> </div>


</div></div>




 
    <button className="MisCpdf-button" onClick={generatePDF}>Download PDF</button>
  </div>
  
  );
}